import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_DELETE_COLLECTION_BEGIN,
  COLLECTIONS_DELETE_COLLECTION_SUCCESS,
  COLLECTIONS_DELETE_COLLECTION_FAILURE,
  COLLECTIONS_DELETE_COLLECTION_DISMISS_ERROR,
} from './constants';

import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function deleteCollection(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_COLLECTION_BEGIN,
    });
    const { projectId, collectionId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${collectionId}`;
      if (args.page || args.page === 0) {
        url += `?limit=${10}&&page=${args.page}&&totalPages=${args.totalPages}`;
      }
      const doRequest = axios.delete(url, header);
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_SUCCESS,
              id: args.collectionId,
            });
            Mixpanel.track('Deleted Collection', { uuid: args.collectionId });
            toast.success('Collection Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_COLLECTION_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Delete Collection Failed');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion Failed: ${errMsg} `);
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_COLLECTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Delete Collection Failed');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg} `);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteCollectionError() {
  return {
    type: COLLECTIONS_DELETE_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_COLLECTION_BEGIN:
      return {
        ...state,
        deleteCollectionPending: true,
        deleteCollectionError: null,
      };

    case COLLECTIONS_DELETE_COLLECTION_SUCCESS:
      const items = state.projectCollections.filter((item) => item.uuid !== action.id);
      return {
        ...state,
        deleteCollectionPending: false,
        deleteCollectionError: null,
        projectCollections: items,
      };

    case COLLECTIONS_DELETE_COLLECTION_FAILURE:
      return {
        ...state,
        deleteCollectionPending: false,
        deleteCollectionError: action.data.error,
      };

    case COLLECTIONS_DELETE_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        deleteCollectionError: null,
      };

    default:
      return state;
  }
}
